/* eslint-disable import/prefer-default-export */
import {trackEvent} from './listeners/analytics';
import {stripTags, isInternalLink} from "./filters";

// eslint-disable-next-line no-unused-vars
export const trackEventByUrl = (link, title, category = null) => {
    const extension = link.substr(link.lastIndexOf('.') + 1);
    const trackTitle = stripTags(title);

    // Track All PDF Clicks
    if (['pdf'].includes(extension)) {
        trackEvent('PDF Clicks', link, trackTitle);
        return true;
    }

    // External Links
    if (!isInternalLink(link)) {
        trackEvent('External Link Click', link, trackTitle);
        return true;
    }

    return true;
};



// WEBPACK FOOTER //
// ./frontend/helpers/events.js